<template>
    <div class="related-to-page">
        <ul>
            <li :class="{ active: isActive('/archaic/overview') }">
                <router-link to="/archaic/overview">Overview</router-link>
            </li>
            <li :class="{ active: isActive('/archaic/maps') }">
                <router-link to="/archaic/maps">Map</router-link>
            </li>
            <li :class="{ active: isActive('/archaic/results') }">
                <router-link to="/archaic/results">Results</router-link>
            </li>
            <li :class="{ active: isActive('/archaic/traits') }">
                <router-link to="/archaic/traits">Traits</router-link>
            </li>
            <li :class="{ active: isActive('/archaic/references') }">
                <router-link to="/archaic/references">References</router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "ArchaicNavigation",
    computed: {
        // Access the current route
        currentRoute() {
            return this.$route.path;
        },
    },
    methods: {
        // Determine if the route matches the current path
        isActive(path) {
            return this.currentRoute === path;
        },
    },
};
</script>
